import React from "react";
import styled from "styled-components";

export const Nav = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  padding-left: ${({ theme }) => theme.space[theme.frame.px]};
  height: 100vh;
  flex-flow: column wrap;
  font-size: 1rem;
  font-weight: 700;
  width: 10vw;
  display: flex;
  justify-content: center;
  a {
    text-decoration: none;
  }
`;

const NavItemList = styled.div`
  // background-color: blue;
  // width: 50%;
`;

const NavItem = styled.div`
  text-transform: uppercase;
  padding-bottom: 0.2rem;
`;

export default ({ navItems }) => {
  return (
    <Nav>
      <NavItemList>
        {navItems.map((item, i) => {
          const Component = item.component;
          return (
            <NavItem key={i}>
              <Component {...item.props} />
            </NavItem>
          );
        })}
      </NavItemList>
    </Nav>
  );
};



// WEBPACK FOOTER //
// ./src/layouts/menu/default.js